import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { endpoint } from "../../utils/endpoints";
import { handleAdminApiCall, handleApiCall } from "../../apis";
import { toast } from "react-toastify";
import DeleteIcon from "../../assets/image/delete.png";

const EVENT_TYPE_OPTIONS = [
  "Corporate Events", "Birthdays", "Anniversary", "Baby Shower", "Naming Ceremony",
  "Anna Prassana", "Half Saree Ceremony", "Social Events - Engagement", "Milestone Events",
  "Puja Rituals", "Pre Wedding - Sangeeth", "Mehendi", "Haldi", "Cocktail", "Carnival",
  "Bride and Groom ceremany", "Post Wedding", "Dhoti Ceremony", "Upanayanam", "House Warming",
  "Memorial Services", "Business events", "Other Events", "Wedding Day", "Kashi Yatra",
  "Bridal Shower", "Kanyadan & Wedding", "Special Night", "Satyanarayana Puja", "Other Cultural Events",
];

// Category field config: return array of rows, each row = array of { type, name, placeholder, options?, isMulti? }
const getCategoryFieldsConfig = (categoryName) => {
  const category = categoryName?.toLowerCase() || "";

  if (category === "recycling" || category.includes("recycling")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "text",
          name: "customization",
          placeholder: "Customization",
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "gender",
          placeholder: "Select Gender",
          options: ["Male", "Female", "Unisex", "Kids", "All"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "pickUpOptions",
          placeholder: "Select Pick-Up Options",
          options: [
            "Home Pickup",
            "Drop-off Location",
            "Scheduled Pickup",
            "On-Demand Pickup",
            "Bulk Pickup",
            "Custom Pickup",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "customerReviews",
          placeholder: "Select Customer Reviews",
          options: [
            "4+ Stars",
            "4.5+ Stars",
            "5 Stars Only",
            "Verified Reviews",
            "All Reviews",
            "No Reviews Required",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "certifications",
          placeholder: "Select Certifications",
          options: [
            "ISO Certified",
            "Environmental Certified",
            "Government Approved",
            "Industry Certified",
            "Quality Certified",
            "No Certification Required",
          ],
          isMulti: false,
        },
      ],
    ];
  }

  if (
    category === "invitations" ||
    category === "gifting" ||
    category.includes("invitation") ||
    category.includes("gift")
  ) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "text",
          name: "customization",
          placeholder: "Customization",
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "gender",
          placeholder: "Select Gender",
          options: ["Male", "Female", "Unisex", "Kids", "All"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "languagePreference",
          placeholder: "Select Language Preference",
          options: [
            "English",
            "Hindi",
            "Telugu",
            "Tamil",
            "Kannada",
            "Malayalam",
            "Bengali",
            "Marathi",
            "Gujarati",
            "Punjabi",
            "Urdu",
            "Sanskrit",
            "Multiple Languages",
            "Other",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "recipientType",
          placeholder: "Select Recipient Type",
          options: [
            "Individual",
            "Couple",
            "Family",
            "Corporate",
            "Bulk Orders",
            "Custom",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "sizeDimensions",
          placeholder: "Select Size/Dimensions",
          options: [
            "Small",
            "Medium",
            "Large",
            "Extra Large",
            "Custom Size",
            "Standard Sizes",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "pickUpOptions",
          placeholder: "Select Pick-Up Options",
          options: [
            "Home Pickup",
            "Drop-off Location",
            "Scheduled Pickup",
            "On-Demand Pickup",
            "Bulk Pickup",
            "Custom Pickup",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "customerReviews",
          placeholder: "Select Customer Reviews",
          options: [
            "4+ Stars",
            "4.5+ Stars",
            "5 Stars Only",
            "Verified Reviews",
            "All Reviews",
            "No Reviews Required",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "certifications",
          placeholder: "Select Certifications",
          options: [
            "ISO Certified",
            "Environmental Certified",
            "Government Approved",
            "Industry Certified",
            "Quality Certified",
            "No Certification Required",
          ],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "bulkPurchaseOptions",
          placeholder: "Select Bulk Purchase Options",
          options: [
            "Available",
            "Not Available",
            "Discount on Bulk",
            "Minimum Quantity Required",
            "Custom Pricing",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "deliveryOptions",
          placeholder: "Select Delivery Options",
          options: [
            "Home Delivery",
            "Pickup",
            "Express Delivery",
            "Standard Delivery",
            "International Delivery",
            "Custom Delivery",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "returnPolicy",
          placeholder: "Select Return Policy",
          options: [
            "No Returns",
            "7 Days Return",
            "14 Days Return",
            "30 Days Return",
            "Exchange Only",
            "Custom Policy",
          ],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "availability",
          placeholder: "Select Availability",
          options: [
            "In Stock",
            "Out of Stock",
            "Pre-order",
            "Made to Order",
            "Limited Stock",
            "Custom Availability",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "themeStyle",
          placeholder: "Select Theme/Style",
          options: [
            "Traditional",
            "Modern",
            "Contemporary",
            "Vintage",
            "Minimalist",
            "Luxury",
            "Rustic",
            "Floral",
            "Geometric",
            "Custom Design",
          ],
          isMulti: false,
        },
      ],
    ];
  }

  if (
    category === "management services" ||
    category.includes("management") ||
    category.includes("service")
  ) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "text",
          name: "customization",
          placeholder: "Customization",
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "gender",
          placeholder: "Select Gender",
          options: ["Male", "Female", "Unisex", "Kids", "All"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "languagePreference",
          placeholder: "Select Language Preference",
          options: [
            "English",
            "Hindi",
            "Telugu",
            "Tamil",
            "Kannada",
            "Malayalam",
            "Bengali",
            "Marathi",
            "Gujarati",
            "Punjabi",
            "Urdu",
            "Sanskrit",
            "Multiple Languages",
            "Other",
          ],
          isMulti: false,
        },
      ],
    ];
  }

  if (category === "pandits" || category.includes("pandit")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "text",
          name: "customization",
          placeholder: "Customization",
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "gender",
          placeholder: "Select Gender",
          options: ["Male", "Female", "Unisex", "Kids", "All"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "languagePreference",
          placeholder: "Select Language Preference",
          options: [
            "English",
            "Hindi",
            "Telugu",
            "Tamil",
            "Kannada",
            "Malayalam",
            "Bengali",
            "Marathi",
            "Gujarati",
            "Punjabi",
            "Urdu",
            "Sanskrit",
            "Multiple Languages",
            "Other",
          ],
          isMulti: false,
        },
      ],
    ];
  }

  // Beauty and Wellness category fields configuration
  if (
    category === "beauty and wellness" ||
    category.includes("beauty") ||
    category.includes("wellness")
  ) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "dropdown",
          name: "customization",
          placeholder: "Customization",
          options: ["Available", "Not Available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "gender",
          placeholder: "Select Gender",
          options: ["Male", "Female", "Unisex", "Kids", "All"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "signatureStyle",
          placeholder: "Select Signature Style",
          options: [
            "Traditional",
            "Modern",
            "Fusion",
            "Western",
            "Indo-Western",
            "Ethnic",
            "Casual",
            "Formal",
            "Bridal",
            "Designer",
            "Custom",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "typeOfConcern",
          placeholder: "Select Type Of Concern",
          options: [
            "Hair Care",
            "Skin Care",
            "Makeup",
            "Nail Care",
            "Spa & Massage",
            "Facial",
            "Hair Styling",
            "Bridal Makeup",
            "Hair Treatment",
            "Body Care",
            "Wellness Therapy",
            "Other",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "languagePreference",
          placeholder: "Select Language Preference",
          options: [
            "English",
            "Hindi",
            "Telugu",
            "Tamil",
            "Kannada",
            "Malayalam",
            "Bengali",
            "Marathi",
            "Gujarati",
            "Punjabi",
            "Urdu",
            "Sanskrit",
            "Multiple Languages",
            "Other",
          ],
          isMulti: false,
        },
      ],
    ];
  }

  // Grooming category fields configuration
  if (category === "grooming" || category.includes("grooming")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "dropdown",
          name: "customization",
          placeholder: "Customization",
          options: ["Available", "Not Available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
      ],
    ];
  }

  // Clothing category fields configuration
  if (category === "clothing" || category.includes("clothing")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "dropdown",
          name: "customization",
          placeholder: "Customization",
          options: ["Available", "Not Available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "gender",
          placeholder: "Select Gender",
          options: ["Male", "Female", "Unisex", "Kids", "All"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "signatureStyle",
          placeholder: "Select Signature Style",
          options: [
            "Traditional",
            "Modern",
            "Fusion",
            "Western",
            "Indo-Western",
            "Ethnic",
            "Casual",
            "Formal",
            "Bridal",
            "Designer",
            "Custom",
          ],
          isMulti: false,
        },
      ],
    ];
  }

  // Photography category fields configuration
  if (category === "photography" || category.includes("photography")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "dropdown",
          name: "customization",
          placeholder: "Customization",
          options: ["Available", "Not Available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
      ],
      [
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "rentCost",
          placeholder: "Select Rent Cost",
          options: ["₹100", "₹500", "₹1500", "₹3000"],
          isMulti: true,
          hasSlider: true,
        },
      ],
      [
        {
          type: "dropdown",
          name: "starCategory",
          placeholder: "Select Star Category",
          options: [
            "1 Stars & Above",
            "2 Stars & Above",
            "3 Stars & Above",
            "4 Stars & Above",
            "5 Star",
          ],
          isMulti: true,
        },
      ],
    ];
  }

  // Videography category fields configuration
  if (category === "videography" || category.includes("videography")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "dropdown",
          name: "customization",
          placeholder: "Customization",
          options: ["Available", "Not Available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
      ],
    ];
  }

  // Entertainment category fields configuration
  if (category === "entertainment" || category.includes("entertainment")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "dropdown",
          name: "customization",
          placeholder: "Customization",
          options: ["Available", "Not Available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "travelPolicy",
          placeholder: "Select Travel Policy",
          options: [
            "Flexible",
            "Moderate",
            "Strict",
            "No Refund",
            "Custom Policy",
          ],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
      ],
      [
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "rentCost",
          placeholder: "Select Rent Cost",
          options: ["₹100", "₹500", "₹1500", "₹3000"],
          isMulti: true,
          hasSlider: true,
        },
      ],
      [
        {
          type: "dropdown",
          name: "starCategory",
          placeholder: "Select Star Category",
          options: [
            "1 Stars & Above",
            "2 Stars & Above",
            "3 Stars & Above",
            "4 Stars & Above",
            "5 Star",
          ],
          isMulti: true,
        },
      ],
    ];
  }

  // Decor category fields configuration
  if (category === "decor" || category.includes("decor")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "dropdown",
          name: "customization",
          placeholder: "Customization",
          options: ["Available", "Not Available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        {
          type: "dropdown",
          name: "discount",
          placeholder: "Select Discount",
          options: ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"],
          isMulti: false,
        },
      ],
      [
        { type: "text", name: "travelPolicy", placeholder: "Travel Policy" },
        {
          type: "dropdown",
          name: "theme",
          placeholder: "Select Theme",
          options: [
            "Traditional",
            "Modern",
            "Rustic",
            "Vintage",
            "Bohemian",
            "Minimalist",
            "Luxury",
            "Garden",
            "Beach",
            "Royal",
            "Floral",
            "Contemporary",
            "Other",
          ],
          isMulti: true,
        },
      ],
    ];
  }

  // Venue category fields configuration
  if (category === "venue" || category.includes("venue")) {
    return [
      [
        {
          type: "number",
          name: "experience",
          placeholder: "Established Year",
        },
        {
          type: "dropdown",
          name: "customization",
          placeholder: "Customization",
          options: ["Available", "Not Available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "eventType",
          placeholder: "Select Event Type",
          options: EVENT_TYPE_OPTIONS,
          isMulti: true,
        },
      ],
      [
        {
          type: "number",
          name: "travelAndAccommodationCharges",
          placeholder: "Travel & Accommodation charges",
        },
        {
          type: "dropdown",
          name: "package",
          placeholder: "Select Package",
          options: ["Basic", "Standard", "Premium", "Custom Packages"],
          isMulti: true,
        },
        { type: "number", name: "discount", placeholder: "Discount" },
      ],
      [
        { type: "text", name: "travelPolicy", placeholder: "Travel Policy" },
        {
          type: "number",
          name: "guestCount",
          placeholder: "Guest Count",
        },
        { type: "text", name: "roomCount", placeholder: "Room Count" },
      ],
      [
        {
          type: "number",
          name: "capacity",
          placeholder: "Capacity",
        },
        {
          type: "dropdown",
          name: "rentCost",
          placeholder: "Select Rent Cost",
          options: ["₹100", "₹500", "₹1500", "₹3000"],
          isMulti: true,
          hasSlider: true,
        },
        {
          type: "dropdown",
          name: "starCategory",
          placeholder: "Select Star Category",
          options: [
            "1 Stars & Above",
            "2 Stars & Above",
            "3 Stars & Above",
            "4 Stars & Above",
            "5 Star",
          ],
          isMulti: true,
        },
      ],
      [
        { type: "text", name: "dimensions", placeholder: "Dimensions" },
        {
          type: "dropdown",
          name: "accessibility",
          placeholder: "Accessibility",
          options: ["Wheelchair Available", "Wheelchair not available"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "avEquipment",
          placeholder: "AV Equipment",
          options: ["Yes", "No"],
          isMulti: false,
        },
      ],
      [
        {
          type: "dropdown",
          name: "wifi",
          placeholder: "WiFi",
          options: ["Yes", "No"],
          isMulti: false,
        },
        {
          type: "dropdown",
          name: "spaceType",
          placeholder: "Select Space Type",
          options: [
            "Indoor",
            "Private Rooms",
            "Garden/Poolside Spaces",
            "Open Fields",
            "Beachside",
            "Others",
          ],
          isMulti: false,
        },
        {
          type: "text",
          name: "parkingCapacity",
          placeholder: "Parking Capacity",
        },
      ],
      // Row 7
      [
        {
          type: "text",
          name: "cateringPolicy",
          placeholder: "Catering Policy",
        },
        { type: "text", name: "djPolicy", placeholder: "DJ Policy" },
        { type: "text", name: "alcoholPolicy", placeholder: "Alcohol Policy" },
      ],
      // Row 8
      [{ type: "text", name: "decorPolicy", placeholder: "Decor Policy" }],
    ];
  }

  // Default/empty configuration for other categories (will be extended later)
  return [];
};

/** Field labels (inline style so they always show; not dependent on Tailwind purge) */
const ADD_SERVICE_LABEL_STYLE = {
  display: "block",
  fontSize: 13,
  fontWeight: 600,
  color: "#1a1a1a",
  marginBottom: 8,
  lineHeight: 1.35,
  fontFamily: "inherit",
};

const AddService = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get service ID and service object from location state
  const serviceId = location?.state?.serviceId;
  const service = location?.state?.service;
  const listingIdFromState = location?.state?.id;
  const listingId =
    typeof listingIdFromState === "string"
      ? listingIdFromState
      : listingIdFromState?._id;
  const isEditMode = !!listingId;

  // Fetched listing data for edit (same API as ViewService)
  const [editingListing, setEditingListing] = useState(null);
  const [editLoading, setEditLoading] = useState(false);
  const [requestApprovalLoading, setRequestApprovalLoading] = useState(false);

  const categoryName =
    service?.name || editingListing?.service_id?.name || "";

  // Get category-specific fields configuration
  const categoryFields = getCategoryFieldsConfig(categoryName);

  // Helper function to get dropdown state
  const getDropdownState = (fieldName) => {
    const stateMap = {
      customization: {
        isOpen: isCustomizationOpen,
        setIsOpen: setIsCustomizationOpen,
        selected: selectedCustomization,
        setSelected: setSelectedCustomization,
      },
      eventType: {
        isOpen: isEventTypeOpen,
        setIsOpen: setIsEventTypeOpen,
        selected: selectedEventTypes,
        setSelected: setSelectedEventTypes,
      },
      package: {
        isOpen: isPackageOpen,
        setIsOpen: setIsPackageOpen,
        selected: selectedPackage,
        setSelected: setSelectedPackage,
      },
      rentCost: {
        isOpen: isRentOpen,
        setIsOpen: setIsRentOpen,
        selected: selectedRentOptions,
        setSelected: setSelectedRentOptions,
      },
      starCategory: {
        isOpen: isStarCategoryOpen,
        setIsOpen: setIsStarCategoryOpen,
        selected: selectedStarCategory,
        setSelected: setSelectedStarCategory,
      },
      spaceType: {
        isOpen: isSpaceTypeOpen,
        setIsOpen: setIsSpaceTypeOpen,
        selected: selectedSpaceTypes,
        setSelected: setSelectedSpaceTypes,
      },
      accessibility: {
        isOpen: isAccessibilityOpen,
        setIsOpen: setIsAccessibilityOpen,
        selected: selectedAccessibility,
        setSelected: setSelectedAccessibility,
      },
      avEquipment: {
        isOpen: isAVEquipmentOpen,
        setIsOpen: setIsAVEquipmentOpen,
        selected: selectedAVEquipment,
        setSelected: setSelectedAVEquipment,
      },
      wifi: {
        isOpen: isWiFiOpen,
        setIsOpen: setIsWiFiOpen,
        selected: selectedWiFi,
        setSelected: setSelectedWiFi,
      },
      discount: {
        isOpen: isDiscountOpen,
        setIsOpen: setIsDiscountOpen,
        selected: selectedDiscount,
        setSelected: setSelectedDiscount,
      },
      theme: {
        isOpen: isThemeOpen,
        setIsOpen: setIsThemeOpen,
        selected: selectedThemes,
        setSelected: setSelectedThemes,
      },
      travelPolicy: {
        isOpen: isTravelPolicyOpen,
        setIsOpen: setIsTravelPolicyOpen,
        selected: selectedTravelPolicy,
        setSelected: setSelectedTravelPolicy,
      },
      gender: {
        isOpen: isGenderOpen,
        setIsOpen: setIsGenderOpen,
        selected: selectedGender,
        setSelected: setSelectedGender,
      },
      signatureStyle: {
        isOpen: isSignatureStyleOpen,
        setIsOpen: setIsSignatureStyleOpen,
        selected: selectedSignatureStyle,
        setSelected: setSelectedSignatureStyle,
      },
      typeOfConcern: {
        isOpen: isTypeOfConcernOpen,
        setIsOpen: setIsTypeOfConcernOpen,
        selected: selectedTypeOfConcern,
        setSelected: setSelectedTypeOfConcern,
      },
      languagePreference: {
        isOpen: isLanguagePreferenceOpen,
        setIsOpen: setIsLanguagePreferenceOpen,
        selected: selectedLanguagePreference,
        setSelected: setSelectedLanguagePreference,
      },
      recipientType: {
        isOpen: isRecipientTypeOpen,
        setIsOpen: setIsRecipientTypeOpen,
        selected: selectedRecipientType,
        setSelected: setSelectedRecipientType,
      },
      sizeDimensions: {
        isOpen: isSizeDimensionsOpen,
        setIsOpen: setIsSizeDimensionsOpen,
        selected: selectedSizeDimensions,
        setSelected: setSelectedSizeDimensions,
      },
      bulkPurchaseOptions: {
        isOpen: isBulkPurchaseOptionsOpen,
        setIsOpen: setIsBulkPurchaseOptionsOpen,
        selected: selectedBulkPurchaseOptions,
        setSelected: setSelectedBulkPurchaseOptions,
      },
      deliveryOptions: {
        isOpen: isDeliveryOptionsOpen,
        setIsOpen: setIsDeliveryOptionsOpen,
        selected: selectedDeliveryOptions,
        setSelected: setSelectedDeliveryOptions,
      },
      returnPolicy: {
        isOpen: isReturnPolicyOpen,
        setIsOpen: setIsReturnPolicyOpen,
        selected: selectedReturnPolicy,
        setSelected: setSelectedReturnPolicy,
      },
      availability: {
        isOpen: isAvailabilityOpen,
        setIsOpen: setIsAvailabilityOpen,
        selected: selectedAvailability,
        setSelected: setSelectedAvailability,
      },
      themeStyle: {
        isOpen: isThemeStyleOpen,
        setIsOpen: setIsThemeStyleOpen,
        selected: selectedThemeStyle,
        setSelected: setSelectedThemeStyle,
      },
      pickUpOptions: {
        isOpen: isPickUpOptionsOpen,
        setIsOpen: setIsPickUpOptionsOpen,
        selected: selectedPickUpOptions,
        setSelected: setSelectedPickUpOptions,
      },
      customerReviews: {
        isOpen: isCustomerReviewsOpen,
        setIsOpen: setIsCustomerReviewsOpen,
        selected: selectedCustomerReviews,
        setSelected: setSelectedCustomerReviews,
      },
      certifications: {
        isOpen: isCertificationsOpen,
        setIsOpen: setIsCertificationsOpen,
        selected: selectedCertifications,
        setSelected: setSelectedCertifications,
      },
    };
    return stateMap[fieldName] || null;
  };

  // Render a single field based on its configuration
  const renderField = (field) => {
    const labelText = field.label || field.placeholder || field.name;
    const fieldId = `svc-field-${field.name}`;
    const inputType =
      field.name === "travelAndAccommodationCharges" ? "text" : field.type;

    if (field.type === "text" || field.type === "number") {
      return (
        <div className="w-full">
          <label htmlFor={fieldId} style={ADD_SERVICE_LABEL_STYLE}>
            {labelText}
          </label>
          <input
            id={fieldId}
            type={inputType}
            name={field.name}
            placeholder={field.placeholder}
            value={formData[field.name] || ""}
            onChange={handleInputChange}
            className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
          />
        </div>
      );
    }

    if (field.type === "dropdown") {
      const dropdownState = getDropdownState(field.name);
      if (!dropdownState) return null;

      const { isOpen, setIsOpen, selected, setSelected } = dropdownState;
      // Multi-select allowed only for: eventType, theme (extend as needed); spaceType is single select
      const allowedMultiSelect = ["eventType", "theme"].includes(
        field.name
      );
      const isMulti = allowedMultiSelect ? field.isMulti !== false : false;
      const options =
        field.name === "eventType" && eventTypeOptions.length > 0
          ? eventTypeOptions
          : field.options || [];
      let displayValue;
      if (field.name === "rentCost") {
        displayValue =
          Array.isArray(selected) && selected.length > 0
            ? selected.join(", ")
            : `Rent Cost: ₹${rentValue}`;
      } else {
        displayValue = isMulti
          ? Array.isArray(selected) && selected.length > 0
            ? selected.join(", ")
            : field.placeholder
          : (Array.isArray(selected) && selected.length === 0) || selected === "" || selected == null
            ? field.placeholder
            : selected;
      }

      return (
        <div className="w-full">
          <span id={`${fieldId}-lbl`} style={ADD_SERVICE_LABEL_STYLE}>
            {labelText}
          </span>
          <div
            className="relative"
            style={
              field.name === "rentCost"
                ? { border: "1px solid rgba(229, 115, 57, 0.4)" }
                : {}
            }
            role="group"
            aria-labelledby={`${fieldId}-lbl`}
          >
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                setIsOpen(!isOpen);
              }}
              className="w-full bg-white px-3 py-2 flex items-center justify-between text-sm min-h-[42px]"
              style={
                field.name !== "rentCost"
                  ? {
                      border: "1px solid rgba(229, 115, 57, 0.4)",
                    }
                  : {}
              }
              aria-expanded={isOpen}
              aria-haspopup="listbox"
            >
              <span className="text-[13px] font-Montserratmedium text-[#2B2B2B] truncate text-left">
                {displayValue}
              </span>
              <span className="text-xs text-[#F4802C] ml-2 flex-shrink-0">▾</span>
            </button>

            {isOpen && (
              <div
                className="absolute left-0 top-full mt-1 w-full bg-white border border-[#F3B37C] rounded-sm shadow-lg z-50 max-h-64 overflow-y-auto"
                onClick={(e) => e.stopPropagation()}
              >
                {field.hasSlider && field.name === "rentCost" ? (
                  <div className="p-3">
                    <input
                      type="range"
                      min={0}
                      max={500000}
                      step={1000}
                      value={rentValue}
                      onChange={(e) => setRentValue(Number(e.target.value))}
                      className="w-full accent-[#F4802C]"
                    />
                    <div className="text-[11px] text-[#262626] mt-1 flex justify-between">
                      <span>₹{rentValue.toLocaleString("en-IN")}</span>
                      <span>₹5,00,000</span>
                    </div>
                  </div>
                ) : (
                  <ul className="py-2">
                    {options.map((option, index) => {
                      const isSelected = isMulti
                        ? Array.isArray(selected) && selected.includes(option)
                        : selected === option;
                      return (
                        <li
                          key={index}
                          className="px-3 py-1.5 flex items-center gap-2 text-[13px] font-Montserratmedium text-[#2B2B2B] hover:bg-gray-50 cursor-pointer"
                          onClick={() => {
                            if (isMulti) {
                              setSelected((prev) =>
                                Array.isArray(prev)
                                  ? prev.includes(option)
                                    ? prev.filter((item) => item !== option)
                                    : [...prev, option]
                                  : [option]
                              );
                            } else {
                              setSelected(option);
                              setIsOpen(false);
                            }
                          }}
                        >
                          <input
                            type={isMulti ? "checkbox" : "radio"}
                            checked={isSelected}
                            readOnly
                            className="h-3 w-3"
                          />
                          <span className="flex-1">{option}</span>
                        </li>
                      );
                    })}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>
      );
    }

    return null;
  };

  // State for dropdown toggles
  const [isSubCategoryOpen, setIsSubCategoryOpen] = useState(false);
  const [isLocationOpen, setIsLocationOpen] = useState(false);
  const [isTagsOpen, setIsTagsOpen] = useState(false);
  const [isLabelOpen, setIsLabelOpen] = useState(false);
  const [isInquiryOpen, setIsInquiryOpen] = useState(false);
  const [isCustomizationOpen, setIsCustomizationOpen] = useState(false);
  const [isEventTypeOpen, setIsEventTypeOpen] = useState(false);
  const [isPackageOpen, setIsPackageOpen] = useState(false);
  const [isRentOpen, setIsRentOpen] = useState(false);
  const [isStarCategoryOpen, setIsStarCategoryOpen] = useState(false);
  const [isSpaceTypeOpen, setIsSpaceTypeOpen] = useState(false);
  const [isAccessibilityOpen, setIsAccessibilityOpen] = useState(false);
  const [isAVEquipmentOpen, setIsAVEquipmentOpen] = useState(false);
  const [isWiFiOpen, setIsWiFiOpen] = useState(false);
  const [isDiscountOpen, setIsDiscountOpen] = useState(false);
  const [isThemeOpen, setIsThemeOpen] = useState(false);
  const [isTravelPolicyOpen, setIsTravelPolicyOpen] = useState(false);
  const [isGenderOpen, setIsGenderOpen] = useState(false);
  const [isSignatureStyleOpen, setIsSignatureStyleOpen] = useState(false);
  const [isTypeOfConcernOpen, setIsTypeOfConcernOpen] = useState(false);
  const [isLanguagePreferenceOpen, setIsLanguagePreferenceOpen] =
    useState(false);
  const [isRecipientTypeOpen, setIsRecipientTypeOpen] = useState(false);
  const [isSizeDimensionsOpen, setIsSizeDimensionsOpen] = useState(false);
  const [isBulkPurchaseOptionsOpen, setIsBulkPurchaseOptionsOpen] =
    useState(false);
  const [isDeliveryOptionsOpen, setIsDeliveryOptionsOpen] = useState(false);
  const [isReturnPolicyOpen, setIsReturnPolicyOpen] = useState(false);
  const [isAvailabilityOpen, setIsAvailabilityOpen] = useState(false);
  const [isThemeStyleOpen, setIsThemeStyleOpen] = useState(false);
  const [isPickUpOptionsOpen, setIsPickUpOptionsOpen] = useState(false);
  const [isCustomerReviewsOpen, setIsCustomerReviewsOpen] = useState(false);
  const [isCertificationsOpen, setIsCertificationsOpen] = useState(false);

  // Selected values for dropdowns
  const [selectedSubCategory, setSelectedSubCategory] = useState(null); // Single select
  const [selectedLocation, setSelectedLocation] = useState(""); // Changed to single select
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [selectedInquiry, setSelectedInquiry] = useState("");
  const [selectedCustomization, setSelectedCustomization] = useState("");
  const [selectedEventTypes, setSelectedEventTypes] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(""); // Changed to single select
  const [rentValue, setRentValue] = useState(0);
  const [selectedRentOptions, setSelectedRentOptions] = useState([]);
  const [selectedStarCategory, setSelectedStarCategory] = useState(""); // Changed to single select
  const [selectedSpaceTypes, setSelectedSpaceTypes] = useState([]);
  const [selectedAccessibility, setSelectedAccessibility] = useState("");
  const [selectedAVEquipment, setSelectedAVEquipment] = useState("");
  const [selectedWiFi, setSelectedWiFi] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState("");
  const [selectedThemes, setSelectedThemes] = useState([]);
  const [selectedTravelPolicy, setSelectedTravelPolicy] = useState("");
  const [selectedGender, setSelectedGender] = useState("");
  const [selectedSignatureStyle, setSelectedSignatureStyle] = useState("");
  const [selectedTypeOfConcern, setSelectedTypeOfConcern] = useState("");
  const [selectedLanguagePreference, setSelectedLanguagePreference] =
    useState("");
  const [selectedRecipientType, setSelectedRecipientType] = useState("");
  const [selectedSizeDimensions, setSelectedSizeDimensions] = useState("");
  const [selectedBulkPurchaseOptions, setSelectedBulkPurchaseOptions] =
    useState("");
  const [selectedDeliveryOptions, setSelectedDeliveryOptions] = useState("");
  const [selectedReturnPolicy, setSelectedReturnPolicy] = useState("");
  const [selectedAvailability, setSelectedAvailability] = useState("");
  const [selectedThemeStyle, setSelectedThemeStyle] = useState("");
  const [selectedPickUpOptions, setSelectedPickUpOptions] = useState("");
  const [selectedCustomerReviews, setSelectedCustomerReviews] = useState("");
  const [selectedCertifications, setSelectedCertifications] = useState("");

  // Media states - display (blob or server path) vs submit (server path only, so display stays visible)
  const [coverImage, setCoverImage] = useState("");
  const [coverImageForSubmit, setCoverImageForSubmit] = useState("");
  const [menuImages, setMenuImages] = useState([]);
  const [menuImagesForSubmit, setMenuImagesForSubmit] = useState([]);
  const [isCoverImagePreviewOpen, setIsCoverImagePreviewOpen] = useState(false);
  const [activeMediaTab, setActiveMediaTab] = useState("Photo gallery");
  const [photoGallery, setPhotoGallery] = useState([]);
  const [photoGalleryForSubmit, setPhotoGalleryForSubmit] = useState([]);
  const [videoGallery, setVideoGallery] = useState([]);
  const [videoGalleryForSubmit, setVideoGalleryForSubmit] = useState([]);
  const [portfolio, setPortfolio] = useState([]);
  const [portfolioForSubmit, setPortfolioForSubmit] = useState([]);

  // Availability states - All days closed (unselected) by default for new service
  const [dailyAvailability, setDailyAvailability] = useState({
    monday: { isClosed: true },
    tuesday: { isClosed: true },
    wednesday: { isClosed: true },
    thursday: { isClosed: true },
    friday: { isClosed: true },
    saturday: { isClosed: true },
    sunday: { isClosed: true },
  });
  const [timeSlots, setTimeSlots] = useState({
    Morning: false,
    Afternoon: false,
    Evening: false,
    Night: false,
  });

  // Data lists from API
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [labelsList, setLabelsList] = useState([]);
  const [eventTypeList, setEventTypeList] = useState([]);
  const [eventTypeOptions, setEventTypeOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  // Form fields
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    location: "",
    address: "",
    basePrice: "",
    price: "",
    tax: "",
    actualTax: "",
    experience: "",
    customization: "",
    travelAndAccommodationCharges: "",
    eventType: "",
    discount: "",
    guestCount: "",
    capacity: "",
    travelPolicy: "",
    camera: "",
    lens: "",
    roomCount: "",
    parkingCapacity: "",
    cateringPolicy: "",
    djPolicy: "",
    alcoholPolicy: "",
    decorPolicy: "",
    whatsIncluded: "",
    whatsExcluded: "",
    whatToExpect: "",
    cancellationPolicy: "",
    dimensions: "",
  });

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Single selection for Sub Category with checkbox
  const selectSubCategory = (subCategory) => {
    if (selectedSubCategory?._id === subCategory._id) {
      // If clicking the same subcategory, deselect it
      setSelectedSubCategory(null);
    } else {
      // Select new subcategory
      setSelectedSubCategory(subCategory);
    }
    setIsSubCategoryOpen(false);
  };

  // Location options
  const locationOptions = [
    "Bengaluru",
    "Chennai",
    "Delhi",
    "Goa",
    "Hyderabad",
    "Jaipur",
    "Kolkata",
    "Mumbai",
    "Pune",
    "Vizag",
    "Vijayawada",
  ];

  useEffect(() => {
    if (!listingId) return;
    const fetchListing = async () => {
      try {
        setEditLoading(true);
        const res = await handleApiCall("get", endpoint.viewService(listingId), {});
        const raw = res?.data;
        const data = raw?.data ?? raw ?? {};
        setEditingListing(
          typeof data === "object" && data !== null ? data : null
        );
      } catch (e) {
        console.error("Error fetching listing for edit:", e);
        toast.error("Failed to load listing. Going back.");
        setEditingListing(null);
        navigate(-1);
      } finally {
        setEditLoading(false);
      }
    };
    fetchListing();
  }, [listingId]);

  // Fetch subcategories and tags when component mounts with service ID
  useEffect(() => {
    // In edit mode wait for fetched listing; don't redirect while loading
    if (isEditMode && editLoading) return;
    if (isEditMode && !editingListing) return;

    // In edit mode, get serviceId from editingListing
    const currentServiceId = isEditMode
      ? editingListing?.service_id?._id || editingListing?.service_id
      : serviceId;

    if (currentServiceId) {
      fetchSubCategory(currentServiceId);
      fetchTagsbyID(currentServiceId);
      fetchLabels();

      // Pre-populate form if in edit mode
      if (isEditMode && editingListing) {
        const editServiceName =
          (typeof editingListing.service_id === "object" &&
            editingListing.service_id?.name) ||
          service?.name ||
          "";
        const editCatLower = editServiceName.toLowerCase();
        const isVenueService =
          editCatLower === "venue" || editCatLower.includes("venue");

        // Set form data
        setFormData({
          title: editingListing.title || "",
          description: editingListing.description || "",
          location: editingListing.location || "",
          address: editingListing.address || "",
          basePrice: editingListing.basePrice || "",
          price: editingListing.price || "",
          tax: editingListing.tax ?? editingListing.attributes?.tax ?? "",
          actualTax: (() => {
            const v =
              editingListing.actualTax ??
              editingListing.actual_tax ??
              editingListing.attributes?.actualTax ??
              editingListing.attributes?.actual_tax ??
              editingListing.actualTaxAmount ??
              editingListing.taxAmount ??
              editingListing.pricing?.actual_tax ??
              editingListing.pricing?.actualTax ??
              editingListing.taxDetails?.actual_tax ??
              editingListing.taxDetails?.actualTax ??
              "";
            return v !== "" && v != null ? String(v) : "";
          })(),
          experience: editingListing.experience || "",
          customization: editingListing.customization
            ? "Available"
            : "Not Available",
          travelAndAccommodationCharges:
            editingListing.travelAndAccommodationCharges || "",
          eventType: editingListing.eventType || "",
          discount: editingListing.discount || "",
          guestCount:
            isVenueService && editingListing.guestCount != null
              ? String(editingListing.guestCount)
              : "",
          capacity:
            editingListing.capacity != null
              ? String(editingListing.capacity)
              : "",
          travelPolicy: editingListing.travelPolicy || "",
          camera: editingListing.attributes?.camera || "",
          lens: editingListing.attributes?.lens || "",
          roomCount: editingListing.roomCount || "",
          parkingCapacity:
            editingListing.parkingCapacity != null
              ? String(editingListing.parkingCapacity)
              : "",
          cateringPolicy: editingListing.cateringPolicy || "",
          djPolicy: editingListing.djPolicy || "",
          alcoholPolicy: editingListing.alcoholPolicy || "",
          decorPolicy: editingListing.decorPolicy || "",
          whatsIncluded: editingListing.attributes?.whatsIncluded || "",
          whatsExcluded: editingListing.attributes?.whatsExcluded || "",
          whatToExpect: editingListing.attributes?.whatToExpect || "",
          cancellationPolicy:
            editingListing.attributes?.cancellationPolicy || "",
          dimensions: editingListing.dimensions || "",
        });

        // Set cover image: display uses url/fileName, submit uses id or fileName (path) for API
        if (editingListing.cover_image) {
          const cov = editingListing.cover_image;
          const url = typeof cov === "object" ? (cov?.url || cov?.fileName) : cov;
          const path = typeof cov === "object" ? (cov?.id ?? (cov?.fileName && !String(cov.fileName).startsWith("http") ? cov.fileName : null)) : cov;
          setCoverImage(url || path);
          setCoverImageForSubmit(path || url);
        }

        // Set images (gallery only; display and submit same when loading edit)
        if (editingListing.images && Array.isArray(editingListing.images)) {
          setPhotoGallery(editingListing.images);
          setPhotoGalleryForSubmit(editingListing.images);
        }

        // Set menu images from menuOptions (display and submit same when loading edit)
        if (editingListing.menuOptions && Array.isArray(editingListing.menuOptions)) {
          setMenuImages(editingListing.menuOptions);
          setMenuImagesForSubmit(editingListing.menuOptions);
        }

        // Set videos (display and submit same when loading edit)
        if (editingListing.videos && Array.isArray(editingListing.videos)) {
          setVideoGallery(editingListing.videos);
          setVideoGalleryForSubmit(editingListing.videos);
        }

        // Set portfolio (display and submit same when loading edit)
        if (editingListing.portfolio) {
          const portArr = Array.isArray(editingListing.portfolio)
            ? editingListing.portfolio
            : editingListing.portfolio.split(",").filter(Boolean);
          setPortfolio(portArr);
          setPortfolioForSubmit(portArr);
        }

        // Set customization dropdown if it's a dropdown field
        if (
          editingListing.customization !== undefined &&
          editingListing.customization !== null
        ) {
          const customizationValue =
            editingListing.customization === true ||
            editingListing.customization === "Available"
              ? "Available"
              : "Not Available";
          setSelectedCustomization(customizationValue);
        }

        // Set locations
        if (editingListing.location) {
          const locations = editingListing.location
            .split(",")
            .map((l) => l.trim())
            .filter(Boolean);
          // For single select, use the first location
          setSelectedLocation(locations.length > 0 ? locations[0] : "");
        }

        // Set daily availability if available
        if (editingListing.serviceAvailability) {
          const days = [
            "monday",
            "tuesday",
            "wednesday",
            "thursday",
            "friday",
            "saturday",
            "sunday",
          ];
          const availabilityData = {};
          days.forEach((day) => {
            availabilityData[day] = {
              isClosed:
                editingListing.serviceAvailability[day]?.isClosed !== undefined
                  ? editingListing.serviceAvailability[day].isClosed
                  : true, // Default to closed if not specified
            };
          });
          setDailyAvailability(availabilityData);
        }

        // Set time slots if available
        if (editingListing.serviceAvailability?.slots) {
          const slots = editingListing.serviceAvailability.slots;
          setTimeSlots({
            Morning: slots.includes("Morning"),
            Afternoon: slots.includes("Afternoon"),
            Evening: slots.includes("Evening"),
            Night: slots.includes("Night"),
          });
        }
      }
    } else if (!isEditMode) {
      // If no service ID (and not in edit mode), redirect back or show error
      toast.error("No service selected. Please select a service first.");
      navigate(-1);
    }
  }, [serviceId, isEditMode, editingListing, editLoading]);

  useEffect(() => {
    fetchEventTypes();
  }, []);

  // Keep formData.discount in sync with selectedDiscount so payload always has current value
  useEffect(() => {
    if (selectedDiscount) {
      const num = parseFloat(String(selectedDiscount).replace("%", ""));
      if (!isNaN(num)) {
        setFormData((prev) => ({ ...prev, discount: String(num) }));
      }
    }
  }, [selectedDiscount]);

  useEffect(() => {
    if (isEditMode && editingListing && subCategoryList.length > 0) {
      const subCatId =
        editingListing.sub_categoty_id?._id || editingListing.sub_categoty_id;
      if (subCatId) {
        const subCat = subCategoryList.find((sc) => sc._id === subCatId);
        if (subCat) {
          setSelectedSubCategory(subCat);
        }
      }
    }
  }, [subCategoryList, isEditMode, editingListing]);

  useEffect(() => {
    if (!isEditMode || !editingListing?.eventType || !eventTypeList?.length) return;
    const raw = Array.isArray(editingListing.eventType)
      ? editingListing.eventType
      : typeof editingListing.eventType === "string"
      ? editingListing.eventType.split(",").map((e) => e.trim()).filter(Boolean)
      : [];
    const names = raw.map((value) => {
      if (value == null) return "";
      const idOrName =
        typeof value === "object"
          ? value?.name ?? value?._id ?? ""
          : value;
      const byId = eventTypeList.find(
        (et) =>
          et._id === idOrName ||
          et.name === idOrName ||
          String(et._id) === String(idOrName)
      );
      if (byId) return byId.name;
      return typeof value === "string" ? value : (value?.name ?? value?._id ?? "");
    }).filter(Boolean);
    setSelectedEventTypes(names);
  }, [isEditMode, editingListing?._id, editingListing?.eventType, eventTypeList]);

  useEffect(() => {
    if (isEditMode && editingListing) {
      // Set package (single select)
      if (editingListing.package) {
        setSelectedPackage(editingListing.package);
      }

      // Rent cost from API (slider)
      if (editingListing.rentCost != null && editingListing.rentCost !== "") {
        setRentValue(Number(editingListing.rentCost) || 0);
      }

      // Set starCategory (single select) - map backend "3 Star" to dropdown "3 Stars & Above"
      const rawStarCategory =
        editingListing.starCategory || editingListing.attributes?.starCategory || "";
      if (rawStarCategory) {
        const starCat = String(rawStarCategory).trim();
        const starDisplayMap = {
          "1 Star": "1 Stars & Above",
          "2 Star": "2 Stars & Above",
          "3 Star": "3 Stars & Above",
          "4 Star": "4 Stars & Above",
          "5 Star": "5 Star",
        };
        setSelectedStarCategory(starDisplayMap[starCat] || starCat);
      }

      // eventType from API is array of IDs; names are set in useEffect below via event types API (eventTypeList)
      if (editingListing.eventType && typeof editingListing.eventType === "string") {
        const eventTypes = editingListing.eventType
          .split(",")
          .map((e) => e.trim())
          .filter(Boolean);
        setSelectedEventTypes(eventTypes);
      }

      // Set spaceType (single select) - one value only
      if (editingListing.spaceType) {
        const raw = editingListing.spaceType;
        const single =
          Array.isArray(raw) ? (raw[0] || "") : (typeof raw === "string" ? raw.trim() : raw);
        if (single) setSelectedSpaceTypes(single);
      }

      // Set Bookings and inquiry (service_type) for edit mode (API may return string or array)
      const rawServiceType = editingListing.service_type ?? editingListing.attributes?.inquiryType;
      const serviceTypeValue = rawServiceType != null
        ? (Array.isArray(rawServiceType) ? (rawServiceType[0] || "") : rawServiceType)
        : "";
      if (serviceTypeValue) {
        setSelectedInquiry(serviceTypeValue);
      }

      // Set discount (dropdown: "5%", "10%", etc. - backend stores number)
      if (editingListing.discount !== undefined && editingListing.discount !== null && editingListing.discount !== "") {
        const d = Number(editingListing.discount);
        const discountOptions = ["5%", "10%", "15%", "20%", "25%", "30%", "Custom"];
        const match = discountOptions.find((o) => parseInt(o, 10) === d);
        setSelectedDiscount(match || (Number.isFinite(d) ? `${d}%` : ""));
      }

      // Set travel policy
      if (editingListing.travelPolicy) {
        setSelectedTravelPolicy(editingListing.travelPolicy);
      }

      // Set gender (top level or attributes)
      const genderValue = editingListing.gender || editingListing.attributes?.gender || "";
      if (genderValue) {
        setSelectedGender(genderValue);
      }

      // Set signature style (top level or attributes)
      const signatureValue = editingListing.signatureStyle || editingListing.attributes?.signatureStyle || "";
      if (signatureValue) {
        setSelectedSignatureStyle(signatureValue);
      }

      // Set theme (multi-select; backend may return string or array)
      if (editingListing.theme || editingListing.attributes?.theme) {
        const raw = editingListing.theme || editingListing.attributes?.theme;
        if (Array.isArray(raw)) {
          setSelectedThemes(raw.filter(Boolean));
        } else if (typeof raw === "string") {
          setSelectedThemes(raw.split(",").map((t) => t.trim()).filter(Boolean));
        }
      }
    }
  }, [isEditMode, editingListing]);

  // Set tags in edit mode
  useEffect(() => {
    if (isEditMode && editingListing && tagsList.length > 0) {
      if (editingListing.tag_ids && Array.isArray(editingListing.tag_ids)) {
        const selectedTagsData = editingListing.tag_ids
          .map((tagItem) => {
            // Handle both cases: tagItem can be an ID (string) or an object with _id
            if (typeof tagItem === "string") {
              // It's an ID string
              const tag = tagsList.find((t) => t._id === tagItem);
              return tag ? { _id: tag._id, tag_name: tag.tag_name } : null;
            } else if (tagItem && typeof tagItem === "object") {
              // It's an object - could be populated tag object or just {_id: "..."}
              if (tagItem.tag_name) {
                // It's a populated tag object
                return { _id: tagItem._id, tag_name: tagItem.tag_name };
              } else {
                // It's just an object with _id
                const tag = tagsList.find((t) => t._id === tagItem._id);
                return tag ? { _id: tag._id, tag_name: tag.tag_name } : null;
              }
            }
            return null;
          })
          .filter(Boolean);
        setSelectedTags(selectedTagsData);
      }
    }
  }, [tagsList, isEditMode, editingListing]);

  // Set labels in edit mode
  useEffect(() => {
    if (isEditMode && editingListing && labelsList.length > 0) {
      if (editingListing.labels && Array.isArray(editingListing.labels)) {
        const selectedLabelsData = editingListing.labels
          .map((labelItem) => {
            // Handle both cases: labelItem can be an ID (string) or an object with _id
            if (typeof labelItem === "string") {
              // It's an ID string
              const label = labelsList.find((l) => l._id === labelItem);
              return label ? { _id: label._id, name: label.label_name } : null;
            } else if (labelItem && typeof labelItem === "object") {
              // It's an object - could be populated label object or just {_id: "..."}
              if (labelItem.label_name || labelItem.name) {
                // It's a populated label object
                return {
                  _id: labelItem._id,
                  name: labelItem.label_name || labelItem.name,
                };
              } else {
                // It's just an object with _id
                const label = labelsList.find((l) => l._id === labelItem._id);
                return label
                  ? { _id: label._id, name: label.label_name }
                  : null;
              }
            }
            return null;
          })
          .filter(Boolean);
        setSelectedLabels(selectedLabelsData);
      }
    }
  }, [labelsList, isEditMode, editingListing]);

  // Location is now single select
  const selectLocation = (location) => {
    if (selectedLocation === location) {
      setSelectedLocation(""); // Deselect if clicking the same location
    } else {
      setSelectedLocation(location);
    }
    setIsLocationOpen(false);
  };

  const toggleTag = (tag) => {
    setSelectedTags((prev) => {
      const exists = prev.find((item) => item._id === tag._id);
      if (exists) {
        return prev.filter((item) => item._id !== tag._id);
      } else {
        return [...prev, { _id: tag._id, tag_name: tag.tag_name }];
      }
    });
  };

  const toggleLabel = (label) => {
    setSelectedLabels((prev) => {
      const exists = prev.find((item) => item._id === label._id);
      if (exists) {
        return prev.filter((item) => item._id !== label._id);
      } else {
        return [...prev, { _id: label._id, name: label.label_name }];
      }
    });
  };

  // Static options
  const inquiryOptions = ["Inquiry", "Booking"];
  // Fetch data functions
  const fetchSubCategory = async (serviceId) => {
    try {
      setLoading(true);
      const res = await handleAdminApiCall(
        "get",
        `${endpoint.getSubCategories(serviceId)}`
      );
      if (res?.data?.code === 200) {
        setSubCategoryList(res?.data?.data || []);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const fetchTagsbyID = async (serviceId) => {
    try {
      setLoading(true);
      const res = await handleApiCall(
        "get",
        `${endpoint.getTagsbyID(serviceId)}`
      );
      if (res?.data?.code === 200) {
        setTagsList(res?.data?.data || []);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const fetchLabels = async () => {
    try {
      setLoading(true);
      const res = await handleApiCall("get", endpoint.getLable);
      if (res?.data?.code === 200) {
        setLabelsList(res?.data?.data || []);
      }
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  const fetchEventTypes = async () => {
    try {
      const res = await handleAdminApiCall("get", endpoint.getEventTypes);
      if (res?.data?.code === 200) {
        const rawList = res?.data?.data || [];

        // Normalize event types to have consistent {_id, name} shape
        const normalizedList = Array.isArray(rawList)
          ? rawList
              .map((item) => {
                if (!item) return null;
                const id = item._id || item.id || item.value || null;
                const name =
                  item.name || item.label || item.eventType || item.title || "";
                if (!id || !name) return null;
                return { _id: id, name };
              })
              .filter(Boolean)
          : [];

        if (normalizedList.length > 0) {
          // Store full objects for ID lookup when submitting
          setEventTypeList(normalizedList);

          // Options for dropdown remain an array of names for display
          const nameOptions = normalizedList
            .map((item) => item.name)
            .sort((a, b) => a.localeCompare(b));
          setEventTypeOptions(nameOptions);
        } else if (Array.isArray(rawList)) {
          // Fallback to previous behaviour (names only) if IDs are not present
          const nameOnly = rawList
            .map((item) => (item && item.name ? item.name : ""))
            .filter(Boolean);
          if (nameOnly.length > 0) {
            setEventTypeList([]);
            setEventTypeOptions(nameOnly.sort((a, b) => a.localeCompare(b)));
          }
        }
      }
    } catch (err) {
    }
  };

  const IMG_PH = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='280' height='128'%3E%3Crect fill='%23eee' width='280' height='128'/%3E%3C/svg%3E";

  // File upload functions
  const uploadSingleFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await handleApiCall(
        "post",
        endpoint.uploadSingleFile,
        formData
      );
      if (res?.data?.code === 200) {
        const data = res?.data?.data;
        if (typeof data === "string") return data;
        return data?.url || data?.path || data?.filename || null;
      }
      alert(res?.data?.message || "Failed to upload file");
      return null;
    } catch (err) {
      alert("Something went wrong while uploading the file");
      return null;
    }
  };

  const uploadMultipleFiles = async (files = []) => {
    const fileArray = Array.from(files || []);
    if (!fileArray.length) return [];

    try {
      const uploadPromises = fileArray.map((file) => uploadSingleFile(file));
      const results = await Promise.all(uploadPromises);
      return results.filter(Boolean);
    } catch (err) {
      alert("Something went wrong while uploading files");
      return [];
    }
  };

  // Prepare service availability object
  const prepareServiceAvailability = () => {
    const activeSlots = Object.entries(timeSlots)
      .filter(([_, isActive]) => isActive)
      .map(([slot]) => slot);

    return {
      timezone: "Asia/Kolkata",
      slots: activeSlots,
      ...dailyAvailability,
    };
  };

  // Close all dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = () => {
      setIsSubCategoryOpen(false);
      setIsLocationOpen(false);
      setIsTagsOpen(false);
      setIsLabelOpen(false);
      setIsInquiryOpen(false);
      setIsCustomizationOpen(false);
      setIsEventTypeOpen(false);
      setIsPackageOpen(false);
      setIsRentOpen(false);
      setIsStarCategoryOpen(false);
      setIsSpaceTypeOpen(false);
      setIsAccessibilityOpen(false);
      setIsAVEquipmentOpen(false);
      setIsWiFiOpen(false);
      setIsDiscountOpen(false);
      setIsThemeOpen(false);
      setIsTravelPolicyOpen(false);
      setIsGenderOpen(false);
      setIsSignatureStyleOpen(false);
      setIsTypeOfConcernOpen(false);
      setIsLanguagePreferenceOpen(false);
      setIsRecipientTypeOpen(false);
      setIsSizeDimensionsOpen(false);
      setIsBulkPurchaseOptionsOpen(false);
      setIsDeliveryOptionsOpen(false);
      setIsReturnPolicyOpen(false);
      setIsAvailabilityOpen(false);
      setIsThemeStyleOpen(false);
      setIsPickUpOptionsOpen(false);
      setIsCustomerReviewsOpen(false);
      setIsCertificationsOpen(false);
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  // Main submit function
  const handleAddService = async (e) => {
    e.preventDefault();

    // In edit mode, get serviceId from editingListing
    const currentServiceId = isEditMode
      ? editingListing?.service_id?._id || editingListing?.service_id
      : serviceId;

    if (!currentServiceId) {
      toast.error("No service selected. Please select a service first.");
      return;
    }

    // Comprehensive validation
    if (!selectedSubCategory) {
      toast.error("Please select a Sub Category");
      return;
    }

    if (!formData.title || formData.title.trim() === "") {
      toast.error("Title/Name is required");
      return;
    }

    if (!formData.description || formData.description.trim() === "") {
      toast.error("Description is required");
      return;
    }

    if (!selectedLocation || selectedLocation.trim() === "") {
      toast.error("Location is required");
      return;
    }

    if (!formData.address || formData.address.trim() === "") {
      toast.error("Address is required");
      return;
    }

    if (!formData.basePrice || formData.basePrice === "") {
      toast.error("Base Price is required");
      return;
    }

    if (!formData.price || formData.price === "") {
      toast.error("Actual Price is required");
      return;
    }

    if (!formData.tax || formData.tax === "") {
      toast.error("Tax is required");
      return;
    }

    // Cover image validation - exactly 1 image
    if (!coverImage || coverImage.trim() === "") {
      toast.error("Cover image is required (exactly 1 image)");
      return;
    }

    // Menu images validation - minimum 1, maximum 4
    const category = categoryName?.toLowerCase() || "";
    const showMenuSection =
      category === "catering" ||
      category.includes("catering") ||
      category === "venue" ||
      category.includes("venue");

    if (showMenuSection) {
      if (menuImages.length < 1) {
        toast.error("At least 1 menu image is required");
        return;
      }
      if (menuImages.length > 4) {
        toast.error("Maximum 4 menu images allowed");
        return;
      }
    }

    // Ensure menu images don't exceed maximum even if category doesn't require menu section
    if (menuImages.length > 4) {
      toast.error("Maximum 4 menu images allowed");
      return;
    }

    // Photo gallery validation - minimum 1, no maximum
    if (photoGallery.length < 1) {
      toast.error("At least 1 photo gallery image is required");
      return;
    }

    // Video gallery validation - minimum 1, no maximum
    if (videoGallery.length < 1) {
      toast.error("At least 1 video gallery video is required");
      return;
    }

    // Tags validation - minimum 1
    if (selectedTags.length < 1) {
      toast.error("At least 1 tag is required");
      return;
    }

    // Labels validation - minimum 1
    if (selectedLabels.length < 1) {
      toast.error("At least 1 label is required");
      return;
    }

    // Event types validation - minimum 1
    if (selectedEventTypes.length < 1) {
      toast.error("At least 1 event type is required");
      return;
    }

    // Availability validation - at least one day must be open
    const hasOpenDay = Object.values(dailyAvailability).some(
      (day) => !day.isClosed
    );
    if (!hasOpenDay) {
      toast.error("At least one day must be available");
      return;
    }

    // Check if at least one time slot is selected
    const hasActiveSlot = Object.values(timeSlots).some((isActive) => isActive);
    if (!hasActiveSlot) {
      toast.error("At least one time slot must be selected");
      return;
    }

    // Backend: eventType as array of IDs for PUT (update), or names for POST (create)
    const eventTypeNames = Array.isArray(selectedEventTypes)
      ? selectedEventTypes.filter(Boolean)
      : [];
    const eventTypePayload =
      eventTypeList?.length > 0
        ? eventTypeNames
            .map((name) => eventTypeList.find((et) => et.name === name)?._id)
            .filter(Boolean)
        : eventTypeNames;

    // Theme: support both array (multi-select) and string (from API)
    const themeValue = Array.isArray(selectedThemes)
      ? selectedThemes.filter(Boolean).join(", ")
      : typeof selectedThemes === "string"
      ? selectedThemes
      : "";

    // spaceType only for Venue & Catering (not e.g. Entertainment)
    const isSpaceTypeCategory =
      category === "catering" ||
      category.includes("catering") ||
      category === "venue" ||
      category.includes("venue");
    const spaceTypePayload = isSpaceTypeCategory
      ? (Array.isArray(selectedSpaceTypes) && selectedSpaceTypes.length > 0
          ? selectedSpaceTypes.join(", ")
          : typeof selectedSpaceTypes === "string" && selectedSpaceTypes
          ? selectedSpaceTypes
          : "")
      : undefined;

    // Edit: send id/fileName (path) for every image/video we keep; cover_image only when user changed it. Removed items not in current* so their id is not sent.
    const toPath = (item) => {
      if (typeof item === "string") return item;
      if (typeof item !== "object" || item == null) return "";
      const p = item.id ?? (item.fileName && !String(item.fileName).startsWith("http") ? item.fileName : null);
      return p != null ? String(p) : "";
    };
    const currentImages = (photoGalleryForSubmit.length ? photoGalleryForSubmit : photoGallery).filter(Boolean);
    const currentVideos = (videoGalleryForSubmit.length ? videoGalleryForSubmit : videoGallery).filter(Boolean);
    const currentPortfolio = (portfolioForSubmit.length ? portfolioForSubmit : portfolio).filter(Boolean);
    const currentMenuOptions = (menuImagesForSubmit.length ? menuImagesForSubmit : menuImages).filter(Boolean);
    const currentCover = coverImageForSubmit || coverImage || "";
    const existingCoverPath = editingListing?.cover_image != null && (typeof editingListing.cover_image === "object" ? (editingListing.cover_image?.id ?? (editingListing.cover_image?.fileName && !String(editingListing.cover_image.fileName).startsWith("http") ? editingListing.cover_image.fileName : null)) : editingListing.cover_image);
    const currentCoverPath = typeof currentCover === "object" ? (currentCover?.id ?? (currentCover?.fileName && !String(currentCover.fileName).startsWith("http") ? currentCover.fileName : null) ?? currentCover?.url) : currentCover;
    const coverChanged = isEditMode && currentCover && currentCoverPath !== existingCoverPath;
    const payloadCoverImage = isEditMode ? (coverChanged ? currentCoverPath : null) : currentCoverPath;
    const payloadImages = currentImages.map(toPath).filter(Boolean);
    const payloadVideos = currentVideos.map(toPath).filter(Boolean);
    const payloadPortfolio = currentPortfolio.map(toPath).filter(Boolean);
    const payloadMenuOptions = currentMenuOptions.map(toPath).filter(Boolean);

    // Prepare payload: cover_image and media as path/id strings; only current items (removed = not sent = backend removes)
    const payload = {
      service_id: currentServiceId,
      sub_categoty_id: selectedSubCategory?._id,
      title: formData.title,
      description: formData.description,
      location: selectedLocation || "",
      address: formData.address,
      basePrice: parseFloat(formData.basePrice) || 0,
      price: parseFloat(formData.price) || 0,
      tax: parseFloat(formData.tax) || 0,
      actual_tax: parseFloat(formData.actualTax) || 0,
      experience: parseInt(formData.experience) || 0,
      customization: selectedCustomization
        ? selectedCustomization === "Available"
        : false,
      travelAndAccommodationCharges: formData.travelAndAccommodationCharges || "",
      eventType: eventTypePayload,
      package: selectedPackage || "",
      discount: parseFloat(formData.discount) || parseFloat(String(selectedDiscount).replace("%", "")) || 0,
      ...(category === "venue" || category.includes("venue")
        ? { guestCount: parseInt(formData.guestCount, 10) || 0 }
        : {}),
      travelPolicy: selectedTravelPolicy || formData.travelPolicy || "",
      cancelPolicy: formData.cancellationPolicy || "",
      service_type: selectedInquiry || "",
      ...(payloadCoverImage ? { cover_image: payloadCoverImage } : {}),
      images: payloadImages,
      videos: payloadVideos,
      portfolio: payloadPortfolio,
      menuOptions: payloadMenuOptions,
      // Fields that should be at top level (not in attributes)
      ...(formData.roomCount !== undefined &&
        formData.roomCount !== null &&
        formData.roomCount !== "" && { roomCount: formData.roomCount }),
      ...(formData.parkingCapacity !== undefined &&
        formData.parkingCapacity !== null &&
        formData.parkingCapacity !== "" && {
          parkingCapacity: parseFloat(formData.parkingCapacity) || 0,
        }),
      ...(formData.cateringPolicy !== undefined &&
        formData.cateringPolicy !== null &&
        formData.cateringPolicy !== "" && {
          cateringPolicy: formData.cateringPolicy,
        }),
      ...(formData.djPolicy !== undefined &&
        formData.djPolicy !== null &&
        formData.djPolicy !== "" && { djPolicy: formData.djPolicy }),
      ...(formData.alcoholPolicy !== undefined &&
        formData.alcoholPolicy !== null &&
        formData.alcoholPolicy !== "" && {
          alcoholPolicy: formData.alcoholPolicy,
        }),
      ...(formData.decorPolicy !== undefined &&
        formData.decorPolicy !== null &&
        formData.decorPolicy !== "" && { decorPolicy: formData.decorPolicy }),
      ...(formData.dimensions !== undefined &&
        formData.dimensions !== null &&
        formData.dimensions !== "" && { dimensions: formData.dimensions }),
      // Convert accessibility string to boolean
      ...(selectedAccessibility && {
        accessibility: selectedAccessibility === "Wheelchair Available",
      }),
      // Convert avEquipment string to boolean
      ...(selectedAVEquipment && {
        avEquipment: selectedAVEquipment === "Yes",
      }),
      // Convert wifi string to boolean
      ...(selectedWiFi && {
        wifi: selectedWiFi === "Yes",
      }),
      ...(typeof rentValue === "number" ? { rentCost: rentValue } : {}),
      // Convert starCategory format: "3 Stars & Above" -> "3 Star"
      ...(selectedStarCategory && {
        starCategory: (() => {
          const match = selectedStarCategory.match(/(\d+)\s*Star/);
          if (match) {
            return `${match[1]} Star`;
          }
          return selectedStarCategory;
        })(),
      }),
      // spaceType only for Venue & Catering; omit for other services (e.g. Entertainment)
      ...(spaceTypePayload !== undefined ? { spaceType: spaceTypePayload } : {}),
      ...(formData.capacity !== undefined &&
        formData.capacity !== null &&
        formData.capacity !== "" && {
          capacity: parseInt(formData.capacity, 10) || 0,
        }),
      attributes: {
        ...(formData.camera !== undefined &&
          formData.camera !== null &&
          formData.camera !== "" && { camera: formData.camera }),
        ...(formData.lens !== undefined &&
          formData.lens !== null &&
          formData.lens !== "" && { lens: formData.lens }),
        ...(formData.whatsIncluded !== undefined &&
          formData.whatsIncluded !== null &&
          formData.whatsIncluded !== "" && {
            whatsIncluded: formData.whatsIncluded,
          }),
        ...(formData.whatsExcluded !== undefined &&
          formData.whatsExcluded !== null &&
          formData.whatsExcluded !== "" && {
            whatsExcluded: formData.whatsExcluded,
          }),
        ...(formData.whatToExpect !== undefined &&
          formData.whatToExpect !== null &&
          formData.whatToExpect !== "" && {
            whatToExpect: formData.whatToExpect,
          }),
        ...(formData.cancellationPolicy !== undefined &&
          formData.cancellationPolicy !== null &&
          formData.cancellationPolicy !== "" && {
            cancellationPolicy: formData.cancellationPolicy,
          }),
        ...(selectedInquiry && { inquiryType: selectedInquiry }),
        ...(themeValue ? { theme: themeValue } : {}),
        ...(selectedGender && { gender: selectedGender }),
        ...(selectedSignatureStyle && {
          signatureStyle: selectedSignatureStyle,
        }),
        ...(selectedTypeOfConcern && { typeOfConcern: selectedTypeOfConcern }),
        ...(selectedLanguagePreference && {
          languagePreference: selectedLanguagePreference,
        }),
        ...(selectedRecipientType && { recipientType: selectedRecipientType }),
        ...(selectedSizeDimensions && {
          sizeDimensions: selectedSizeDimensions,
        }),
        ...(selectedBulkPurchaseOptions && {
          bulkPurchaseOptions: selectedBulkPurchaseOptions,
        }),
        ...(selectedDeliveryOptions && {
          deliveryOptions: selectedDeliveryOptions,
        }),
        ...(selectedReturnPolicy && { returnPolicy: selectedReturnPolicy }),
        ...(selectedAvailability && { availability: selectedAvailability }),
        ...(selectedThemeStyle && { themeStyle: selectedThemeStyle }),
        ...(selectedPickUpOptions && { pickUpOptions: selectedPickUpOptions }),
        ...(selectedCustomerReviews && {
          customerReviews: selectedCustomerReviews,
        }),
        ...(selectedCertifications && {
          certifications: selectedCertifications,
        }),
      },
      tag_ids:
        selectedTags.length > 0 ? selectedTags.map((tag) => tag._id) : [],
      labels:
        selectedLabels.length > 0
          ? selectedLabels.map((label) => label._id)
          : [],
      serviceAvailability: prepareServiceAvailability(),
    };

    try {
      setLoading(true);

      // Use update API if in edit mode, otherwise use create API
      const apiEndpoint = isEditMode
        ? endpoint.updateServiceListing(editingListing._id)
        : endpoint.createServiceListing;

      const apiMethod = isEditMode ? "put" : "post";

      const res = await handleApiCall(apiMethod, apiEndpoint, payload);

      if (res?.response) {
        const errorMessage =
          res?.response?.data?.errorMessage ||
          res?.response?.data?.message ||
          res?.data?.message ||
          (isEditMode
            ? "Failed to update service listing"
            : "Failed to create service listing");
        toast.error(errorMessage);
      } else if (res?.data?.code === 200 || res?.data?.code === 201) {
        toast.success(
          isEditMode
            ? "Service listing updated successfully"
            : "Service listing created successfully"
        );
        navigate(-1);
      } else {
        const errorMessage =
          res?.data?.errorMessage ||
          res?.data?.message ||
          (isEditMode
            ? "Failed to update service listing"
            : "Failed to create service listing");
        toast.error(errorMessage);
      }
    } catch (error) {
      toast.error(
        isEditMode
          ? "Something went wrong while updating the service listing"
          : "Something went wrong while creating the service listing"
      );
    } finally {
      setLoading(false);
    }
  };

  const showRequestApprovalButton =
    isEditMode &&
    !editLoading &&
    editingListing &&
    String(
      editingListing.approve_status ?? editingListing.approval_status ?? ""
    ).toLowerCase() === "rejected";

  const handleRequestApproval = async () => {
    const id = editingListing?._id;
    if (!id) {
      toast.error("Listing ID not found");
      return;
    }
    try {
      setRequestApprovalLoading(true);
      const res = await handleApiCall(
        "put",
        endpoint.requestListingApproval(id),
        {}
      );
      if (res?.response) {
        toast.error(
          res?.response?.data?.errorMessage ||
            res?.response?.data?.message ||
            "Failed to request approval"
        );
      } else if (
        res?.data?.code === 200 ||
        res?.data?.code === 201 ||
        res?.data?.success === true
      ) {
        toast.success("Approval requested successfully");
        navigate("/service-management/rejected-services");
      } else {
        toast.error(
          res?.data?.errorMessage ||
            res?.data?.message ||
            "Failed to request approval"
        );
      }
    } catch (e) {
      toast.error("Failed to request approval");
    } finally {
      setRequestApprovalLoading(false);
    }
  };

  // Same loader as ViewService when in edit mode and fetching listing
  if (isEditMode && editLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4">
        <div
          className="w-12 h-12 border-4 border-[#A4B792] border-t-[#E67E22] rounded-full animate-spin"
          aria-hidden="true"
        />
        <p className="text-gray-600 font-Montserratmedium">Loading service details...</p>
      </div>
    );
  }

  return (
    <>
      <div className="min-h-screen pb-8">
        <div className="flex justify-between items-center mb-6">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="text-[13px] font-Montserratregular text-[#E67E22] px-4 py-1.5 text-sm font-regular"
            style={{
              border: "1px solid rgba(229, 115, 57, 0.4)",
            }}
          >
            Back
          </button>
          <div className="flex items-center gap-3">
            {showRequestApprovalButton && (
              <button
                type="button"
                onClick={handleRequestApproval}
                disabled={loading || requestApprovalLoading}
                className="bg-[#a9b591] px-20 py-2.5 text-[13px] font-Montserratmedium text-[#FFFFFF] font-regular disabled:opacity-60"
              >
                {requestApprovalLoading ? "Submitting..." : "Request approval"}
              </button>
            )}
            <button
              type="button"
              onClick={handleAddService}
              disabled={loading}
              className="bg-[#a9b591] px-20 py-2.5 text-[13px] font-Montserratmedium text-[#FFFFFF] font-regular disabled:opacity-60"
            >
              {loading ? "Saving..." : isEditMode ? "Update" : "Add"}
            </button>
          </div>
        </div>

        <form className="space-y-6" onSubmit={handleAddService}>
          {/* Basic Information */}
          {/* First Row: Title/Name, Sub Category, Location */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label htmlFor="add-svc-title" style={ADD_SERVICE_LABEL_STYLE}>
                Title / Name
              </label>
              <input
                id="add-svc-title"
                type="text"
                name="title"
                placeholder="Title / Name"
                value={formData.title}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
                required
              />
            </div>

            {/* Service Sub Category Dropdown */}
            <div>
              <span id="add-svc-subcat-lbl" style={ADD_SERVICE_LABEL_STYLE}>
                Service sub category
              </span>
              <div className="relative" role="group" aria-labelledby="add-svc-subcat-lbl">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsSubCategoryOpen(!isSubCategoryOpen);
                }}
                className="w-full bg-white px-3 py-2 flex items-center justify-between text-sm min-h-[42px]"
                style={{
                  border: "1px solid rgba(229, 115, 57, 0.4)",
                }}
                aria-expanded={isSubCategoryOpen}
              >
                <span className="text-[13px] font-Montserratmedium text-[#2B2B2B] truncate text-left">
                  {selectedSubCategory
                    ? selectedSubCategory.name
                    : "Service Sub Category"}
                </span>
                <span className="text-xs text-[#F4802C] ml-2 flex-shrink-0">
                  ▾
                </span>
              </button>

              {isSubCategoryOpen && (
                <div
                  className="absolute left-0 top-full mt-1 w-full bg-white border border-[#F3B37C] rounded-sm shadow-lg z-50 max-h-64 overflow-y-auto"
                  onClick={(e) => e.stopPropagation()}
                >
                  <ul className="py-2">
                    {subCategoryList.map((subCategory) => {
                      const isSelected =
                        selectedSubCategory?._id === subCategory._id;
                      return (
                        <li
                          key={subCategory._id}
                          className="px-3 py-1.5 flex items-center gap-2 text-[13px] font-Montserratmedium text-[#2B2B2B] hover:bg-gray-50 cursor-pointer"
                          onClick={() => selectSubCategory(subCategory)}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            className="h-3 w-3"
                          />
                          <span className="flex-1">{subCategory.name}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
            </div>

            {/* Location Dropdown */}
            <div>
              <span id="add-svc-loc-lbl" style={ADD_SERVICE_LABEL_STYLE}>
                Location (city)
              </span>
              <div className="relative" role="group" aria-labelledby="add-svc-loc-lbl">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsLocationOpen(!isLocationOpen);
                }}
                className="w-full bg-white px-3 py-2 flex items-center justify-between text-sm min-h-[42px]"
                style={{
                  border: "1px solid rgba(229, 115, 57, 0.4)",
                }}
                aria-expanded={isLocationOpen}
              >
                <span className="text-[13px] font-Montserratmedium text-[#2B2B2B] truncate text-left">
                  {selectedLocation || "Location - City"}
                </span>
                <span className="text-xs text-[#F4802C] ml-2 flex-shrink-0">
                  ▾
                </span>
              </button>

              {isLocationOpen && (
                <div
                  className="absolute left-0 top-full mt-1 w-full bg-white border border-[#F3B37C] rounded-sm shadow-lg z-50 max-h-64 overflow-y-auto"
                  onClick={(e) => e.stopPropagation()}
                >
                  <ul className="py-2">
                    {locationOptions.map((location, index) => {
                      const isSelected = selectedLocation === location;
                      return (
                        <li
                          key={index}
                          className="px-3 py-1.5 flex items-center gap-2 text-[13px] font-Montserratmedium text-[#2B2B2B] hover:bg-gray-50 cursor-pointer"
                          onClick={() => selectLocation(location)}
                        >
                          <input
                            type="radio"
                            name="location"
                            checked={isSelected}
                            readOnly
                            className="h-3 w-3"
                          />
                          <span className="flex-1">{location}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
            </div>
          </div>

          {/* Second Row: Base Price, Actual Price, Tax */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div>
              <label htmlFor="add-svc-base" style={ADD_SERVICE_LABEL_STYLE}>
                Base price
              </label>
              <input
                id="add-svc-base"
                type="number"
                name="basePrice"
                placeholder="Base Price"
                value={formData.basePrice}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
              />
            </div>

            <div>
              <label htmlFor="add-svc-price" style={ADD_SERVICE_LABEL_STYLE}>
                Actual price
              </label>
              <input
                id="add-svc-price"
                type="number"
                name="price"
                placeholder="Actual Price"
                value={formData.price}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
              />
            </div>

            <div>
              <label htmlFor="add-svc-tax" style={ADD_SERVICE_LABEL_STYLE}>
                Tax (GST)
              </label>
              <div className="relative">
              <select
                id="add-svc-tax"
                name="tax"
                value={formData.tax}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] bg-white appearance-none pr-8 w-full"
              >
                <option value="">Select Tax</option>
                <option value="0">No Tax (0%)</option>
                <option value="5">5% GST</option>
                <option value="12">12% GST</option>
                <option value="18">18% GST</option>
                <option value="28">28% GST</option>
              </select>
              <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-xs text-[#F4802C]">
                ▾
              </span>
            </div>
            </div>
          </div>

          {/* Third Row: Actual Tax (1 column), Full Address (2 columns) */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {/* <input
              type="number"
              name="actualTax"
              placeholder="Actual Tax"
              value={formData.actualTax}
              onChange={handleInputChange}
              className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px]"
            /> */}

            <div className="md:col-span-2">
              <label htmlFor="add-svc-address" style={ADD_SERVICE_LABEL_STYLE}>
                Full address
              </label>
              <input
                id="add-svc-address"
                type="text"
                name="address"
                placeholder="Full Address"
                value={formData.address}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
              />
            </div>
          </div>

          <div>
            <label htmlFor="add-svc-desc" style={ADD_SERVICE_LABEL_STYLE}>
              Description
            </label>
            <textarea
              id="add-svc-desc"
              name="description"
              placeholder="Description"
              rows={4}
              value={formData.description}
              onChange={handleInputChange}
              className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
              required
            />
          </div>

          {/* Cover Image */}
          <div>
            <span style={ADD_SERVICE_LABEL_STYLE}>Thumbnail</span>
            {!coverImage ? (
              <label
                htmlFor="cover-upload"
                className="inline-flex w-full max-w-[280px] dashed-upload-box h-28 md:h-32 flex-col items-center justify-center cursor-pointer"
              >
                <img
                  src="/images/upload.png"
                  alt="Upload Icon"
                  className="mx-2 h-5 w-5 mb-2"
                />
                <span className="text-[18px] font-Montserratmedium font-regular text-[#F4802C] text-sm">
                  Upload new photo
                </span>
                <input
                  id="cover-upload"
                  type="file"
                  accept="image/*"
                  className="hidden"
                  onChange={async (e) => {
                    const file = e.target.files?.[0];
                    if (file) {
                      setCoverImage(URL.createObjectURL(file));
                      const url = await uploadSingleFile(file);
                      if (url) setCoverImageForSubmit(url);
                      e.target.value = "";
                    }
                  }}
                />
              </label>
            ) : (
              <div className="inline-flex w-full max-w-[280px] dashed-upload-box h-28 md:h-32 items-center justify-center relative">
                <img
                  src={coverImage || IMG_PH}
                  alt="Cover"
                  className="h-full w-full object-cover cursor-pointer rounded"
                  onClick={() => setIsCoverImagePreviewOpen(true)}
                  onError={(e) => { e.target.src = IMG_PH; }}
                />
                <button
                  type="button"
                  onClick={() => {
                    setCoverImage("");
                    setCoverImageForSubmit("");
                  }}
                  className="absolute bottom-2 left-1/2 -translate-x-1/2 flex h-8 w-8 items-center justify-center rounded-full bg-white border border-[#F3D5BF] shadow-sm hover:bg-[#FFF7F1] transition z-10"
                  aria-label="Remove image"
                >
                  <img
                    src={DeleteIcon}
                    alt="Delete"
                    className="h-3.5 w-3.5 delete-icon-tint"
                  />
                </button>
              </div>
            )}
          </div>

          {/* Cover Image Preview Modal */}
          {isCoverImagePreviewOpen && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-md z-[11111]"
              onClick={() => setIsCoverImagePreviewOpen(false)}
            >
              <div
                className="relative w-full h-full flex items-center justify-center"
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => setIsCoverImagePreviewOpen(false)}
                  className="absolute top-4 right-4 z-20"
                >
                  <img
                    src="/images/cross-full.svg"
                    alt="Close"
                    className="h-7 w-7 tint-icon-white"
                  />
                </button>
                <img
                  src={coverImage || IMG_PH}
                  alt="Cover Preview"
                  className="max-h-[90vh] max-w-[90vw] object-contain rounded-md shadow-lg"
                  onError={(e) => { e.target.src = IMG_PH; }}
                />
              </div>
            </div>
          )}

          <hr className="border-t-2 border-[#ccc] mb-6" />

          {/* ATTRIBUTES Section */}
          <h1 className="text-[25px] font-bold font-poppins text-[#000000] mb-4">
            ATTRIBUTES
          </h1>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <label htmlFor="add-svc-inc" style={ADD_SERVICE_LABEL_STYLE}>
                What&apos;s included
              </label>
              <input
                id="add-svc-inc"
                type="text"
                name="whatsIncluded"
                placeholder="What's Included"
                value={formData.whatsIncluded}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
              />
            </div>

            <div>
              <label htmlFor="add-svc-exc" style={ADD_SERVICE_LABEL_STYLE}>
                What&apos;s excluded
              </label>
              <input
                id="add-svc-exc"
                type="text"
                name="whatsExcluded"
                placeholder="What's Excluded"
                value={formData.whatsExcluded}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
              />
            </div>

            <div>
              <label htmlFor="add-svc-expect" style={ADD_SERVICE_LABEL_STYLE}>
                What can we expect
              </label>
              <input
                id="add-svc-expect"
                type="text"
                name="whatToExpect"
                placeholder="What can we expect"
                value={formData.whatToExpect}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
              />
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div>
              <label htmlFor="add-svc-cancel" style={ADD_SERVICE_LABEL_STYLE}>
                Cancellation policy
              </label>
              <input
                id="add-svc-cancel"
                type="text"
                name="cancellationPolicy"
                placeholder="Cancellation Policy"
                value={formData.cancellationPolicy}
                onChange={handleInputChange}
                className="form-control default text-[13px] font-Montserratmedium text-[#2B2B2B] rounded-none border-[#E57339] border-1 border-opacity-40 min-h-[42px] w-full"
              />
            </div>
          </div>

          <hr className="border-t-2 border-[#ccc] mb-6" />

          {/* Tags, Labels, Inquiry */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {/* Tags Dropdown */}
            <div>
              <span id="add-svc-tags-lbl" style={ADD_SERVICE_LABEL_STYLE}>
                Tags
              </span>
              <div className="relative" role="group" aria-labelledby="add-svc-tags-lbl">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsTagsOpen(!isTagsOpen);
                }}
                className="w-full bg-white px-3 py-2 flex items-center justify-between text-sm min-h-[42px]"
                style={{
                  border: "1px solid rgba(229, 115, 57, 0.4)",
                }}
                aria-expanded={isTagsOpen}
              >
                <span className="text-[13px] font-Montserratmedium text-[#2B2B2B] truncate text-left">
                  {selectedTags.length > 0
                    ? selectedTags.map((tag) => tag.tag_name).join(", ")
                    : "Tags"}
                </span>
                <span className="text-xs text-[#F4802C] ml-2 flex-shrink-0">
                  ▾
                </span>
              </button>

              {isTagsOpen && (
                <div
                  className="absolute left-0 top-full mt-1 w-full bg-white border border-[#F3B37C] rounded-sm shadow-lg z-50 max-h-64 overflow-y-auto"
                  onClick={(e) => e.stopPropagation()}
                >
                  <ul className="py-2">
                    {tagsList.map((tag) => {
                      const isSelected = selectedTags.some(
                        (item) => item._id === tag._id
                      );
                      return (
                        <li
                          key={tag._id}
                          className="px-3 py-1.5 flex items-center gap-2 text-[13px] font-Montserratmedium text-[#2B2B2B] hover:bg-gray-50 cursor-pointer"
                          onClick={() => toggleTag(tag)}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            className="h-3 w-3"
                          />
                          <span className="flex-1">{tag.tag_name}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
            </div>

            {/* Labels Dropdown */}
            <div>
              <span id="add-svc-labels-lbl" style={ADD_SERVICE_LABEL_STYLE}>
                Labels
              </span>
              <div className="relative" role="group" aria-labelledby="add-svc-labels-lbl">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsLabelOpen(!isLabelOpen);
                }}
                className="w-full bg-white px-3 py-2 flex items-center justify-between text-sm min-h-[42px]"
                style={{
                  border: "1px solid rgba(229, 115, 57, 0.4)",
                }}
                aria-expanded={isLabelOpen}
              >
                <span className="text-[13px] font-Montserratmedium text-[#2B2B2B] truncate text-left">
                  {selectedLabels.length > 0
                    ? selectedLabels.map((label) => label.name).join(", ")
                    : "Label"}
                </span>
                <span className="text-xs text-[#F4802C] ml-2 flex-shrink-0">
                  ▾
                </span>
              </button>

              {isLabelOpen && (
                <div
                  className="absolute left-0 top-full mt-1 w-full bg-white border border-[#F3B37C] rounded-sm shadow-lg z-50 max-h-64 overflow-y-auto"
                  onClick={(e) => e.stopPropagation()}
                >
                  <ul className="py-2">
                    {labelsList.map((label) => {
                      const isSelected = selectedLabels.some(
                        (item) => item._id === label._id
                      );
                      return (
                        <li
                          key={label._id}
                          className="px-3 py-1.5 flex items-center gap-2 text-[13px] font-Montserratmedium text-[#2B2B2B] hover:bg-gray-50 cursor-pointer"
                          onClick={() => toggleLabel(label)}
                        >
                          <input
                            type="checkbox"
                            checked={isSelected}
                            readOnly
                            className="h-3 w-3"
                          />
                          <span className="flex-1">{label.label_name}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              )}
            </div>
            </div>

            {/* Inquiry Dropdown */}
            <div>
              <span id="add-svc-inquiry-lbl" style={ADD_SERVICE_LABEL_STYLE}>
                Inquiry or booking
              </span>
              <div className="relative" role="group" aria-labelledby="add-svc-inquiry-lbl">
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  setIsInquiryOpen(!isInquiryOpen);
                }}
                className="w-full bg-white px-3 py-2 flex items-center justify-between text-sm min-h-[42px]"
                style={{
                  border: "1px solid rgba(229, 115, 57, 0.4)",
                }}
                aria-expanded={isInquiryOpen}
              >
                <span className="text-[13px] font-Montserratmedium text-[#2B2B2B] truncate text-left">
                  {selectedInquiry || "Inquiry Or Booking"}
                </span>
                <span className="text-xs text-[#F4802C] ml-2 flex-shrink-0">
                  ▾
                </span>
              </button>

              {isInquiryOpen && (
                <div
                  className="absolute left-0 top-full mt-1 w-full bg-white border border-[#F3B37C] rounded-sm shadow-lg z-50 max-h-64 overflow-y-auto"
                  onClick={(e) => e.stopPropagation()}
                >
                  <ul className="py-2">
                    {inquiryOptions.map((option, index) => (
                      <li
                        key={index}
                        className="px-3 py-1.5 flex items-center gap-2 text-[13px] font-Montserratmedium text-[#2B2B2B] hover:bg-gray-50 cursor-pointer"
                        onClick={() => {
                          setSelectedInquiry(option);
                          setIsInquiryOpen(false);
                        }}
                      >
                        <input
                          type="radio"
                          name="inquiry"
                          checked={selectedInquiry === option}
                          readOnly
                          className="h-3 w-3"
                        />
                        <span className="flex-1">{option}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
            </div>
          </div>

          <hr className="border-t-2 border-[#ccc] mb-6" />

          {/* Category-specific fields - dynamically rendered */}
          {categoryFields.length > 0 &&
            categoryFields.map((row, rowIndex) => (
              <div key={rowIndex} className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                {row.map((field, fieldIndex) => (
                  <div key={fieldIndex}>{renderField(field)}</div>
                ))}
              </div>
            ))}

          {/* MENU Section - Only for Catering and Venue */}
          {(() => {
            const category = categoryName?.toLowerCase() || "";
            const showMenuSection =
              category === "catering" ||
              category.includes("catering") ||
              category === "venue" ||
              category.includes("venue");

            if (!showMenuSection) return null;

            return (
              <>
                <hr className="border-t-2 border-[#ccc] mb-6" />
                <h1 className="text-2xl font-bold text-[#262626] mb-4">MENU</h1>
                <div className="flex flex-col md:flex-row gap-4 items-start mb-6">
                  <div className="w-full md:w-[280px] shrink-0 overflow-hidden shadow-none">
                    <span style={ADD_SERVICE_LABEL_STYLE}>
                      Menu image {menuImages.length + 1}
                    </span>
                    <label
                      htmlFor="menu-image-upload"
                      className="dashed-upload-box w-full h-28 md:h-32 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 transition rounded"
                    >
                      <img
                        src="/images/upload.png"
                        alt="Upload Icon"
                        className="h-8 w-8 mb-3"
                      />
                      <span className="text-[#F4802C] text-sm font-medium">
                        Upload new photo
                      </span>
                      <input
                        id="menu-image-upload"
                        type="file"
                        accept="image/*"
                        multiple
                        className="hidden"
                        onChange={async (e) => {
                          const files = e.target.files
                            ? Array.from(e.target.files)
                            : [];
                          if (files.length) {
                            const blobUrls = files.map((f) => URL.createObjectURL(f));
                            setMenuImages((prev) => [...prev, ...blobUrls]);
                            const urls = await uploadMultipleFiles(files);
                            if (urls.length) {
                              setMenuImagesForSubmit((prev) => [...prev, ...urls]);
                            }
                            e.target.value = "";
                          }
                        }}
                      />
                    </label>
                  </div>

                  <div className="image-strip-scroll flex-1 min-w-0 flex items-start gap-4 overflow-x-auto overflow-y-hidden pb-2">
                    {menuImages.map((image, index) => {
                      const menuImageUrl =
                        typeof image === "string"
                          ? image
                          : (image?.url || image?.path || image?.src || "");
                      return (
                        <div key={index} className="shrink-0 w-[280px] overflow-hidden shadow-sm">
                          <span style={ADD_SERVICE_LABEL_STYLE}>
                            Menu {index + 1}
                          </span>
                          <div className="relative">
                            <img
                              src={menuImageUrl || IMG_PH}
                              alt={`Menu ${index + 1}`}
                              className="w-full h-28 md:h-32 object-cover rounded bg-gray-100"
                              onError={(e) => {
                                e.target.src = IMG_PH;
                              }}
                            />
                            <button
                              type="button"
                              onClick={() => {
                                setMenuImages((prev) => prev.filter((_, i) => i !== index));
                                setMenuImagesForSubmit((prev) => prev.filter((_, i) => i !== index));
                              }}
                              className="absolute bottom-2 left-1/2 -translate-x-1/2 flex h-8 w-8 items-center justify-center rounded-full bg-white border border-[#F3D5BF] shadow-sm hover:bg-[#FFF7F1] transition z-10"
                              aria-label="Remove image"
                            >
                              <img
                                src={DeleteIcon}
                                alt="Delete"
                                className="h-3.5 w-3.5 delete-icon-tint"
                              />
                            </button>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>

                <hr className="border-t-2 border-[#ccc] mb-6" />
              </>
            );
          })()}

          {/* AVAILABILITY Section */}
          <h1 className="text-2xl font-bold text-[#262626]">AVAILABILITY</h1>
          <span
            style={{
              ...ADD_SERVICE_LABEL_STYLE,
              color: "#c45c12",
            }}
          >
            Select availability (by day)
          </span>

          {/* Daily Availability */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
            {Object.entries(dailyAvailability).map(([day, config]) => (
              <div
                key={day}
                className="bg-[#A4B79210] px-4 py-3 flex items-center justify-between"
              >
                <span className="text-[13px] font-Montserratmedium text-[#2B2B2B] capitalize">
                  {day}
                </span>
                <div className="flex items-center gap-3">
                  <span
                    className={`text-[13px] font-Montserratmedium text-[#2B2B2B] opacity-60`}
                  >
                    {config.isClosed ? "Closed" : "Open"}
                  </span>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={!config.isClosed}
                      onChange={(e) => {
                        setDailyAvailability({
                          ...dailyAvailability,
                          [day]: { isClosed: !e.target.checked },
                        });
                      }}
                      className="sr-only peer"
                    />
                    <div
                      className={`w-11 h-6 rounded-full peer peer-focus:outline-none transition-colors ${
                        !config.isClosed ? "bg-[#F4802C]" : "bg-[#A4B792]"
                      }`}
                    >
                      <div
                        className={`w-5 h-5 bg-white rounded-full shadow-md transform transition-transform mt-0.5 ${
                          !config.isClosed
                            ? "translate-x-5 ml-0.5"
                            : "translate-x-0.5"
                        }`}
                      ></div>
                    </div>
                  </label>
                </div>
              </div>
            ))}
          </div>

          {/* Time Slots */}
          <div className="mb-6">
            <span
              style={{
                ...ADD_SERVICE_LABEL_STYLE,
                color: "#c45c12",
              }}
            >
              Time slots
            </span>
            <div className="bg-[#A4B79210] px-4 py-3 rounded-md">
              <div className="flex flex-wrap gap-6">
                {Object.entries(timeSlots).map(([slot, isChecked]) => (
                  <label
                    key={slot}
                    className="flex items-center gap-2 cursor-pointer"
                  >
                    <div className="relative">
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={(e) => {
                          setTimeSlots({
                            ...timeSlots,
                            [slot]: e.target.checked,
                          });
                        }}
                        className="sr-only"
                      />
                      <div
                        className={`w-4 h-4 border-2 transition-colors ${
                          isChecked
                            ? "bg-[#A4B792] border-[#24AF4E]"
                            : "bg-white border-[#F4802C]"
                        }`}
                      ></div>
                    </div>
                    <span className="text-[13px] font-Montserratmedium text-[#2B2B2B]">
                      {slot}
                    </span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <hr className="border-t-2 border-[#ccc] mb-6" />

          {/* MEDIA Section */}
          <h1 className="text-2xl font-bold text-[#262626] mb-4">MEDIA</h1>

          <div className="flex gap-4 mb-6">
            {["Photo gallery", "Video gallery", "Portfolio"].map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActiveMediaTab(tab)}
                className={`px-6 py-2.5 text-[13px] font-Montserratmedium font-medium transition ${
                  activeMediaTab === tab
                    ? "bg-[#F4802C] text-white"
                    : "bg-white text-[#F4802C] border border-[#E57339]"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          <div className="flex flex-col md:flex-row gap-4 items-start mb-6">
            <div className="w-full md:w-[280px] shrink-0">
              <span style={ADD_SERVICE_LABEL_STYLE}>
                {activeMediaTab === "Video gallery"
                  ? "Upload videos"
                  : activeMediaTab === "Portfolio"
                    ? "Upload portfolio"
                    : "Upload photos"}
              </span>
              <label
                htmlFor={`media-upload-${activeMediaTab}`}
                className="dashed-upload-box w-full h-28 md:h-32 flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 transition"
              >
                <img
                  src="/images/upload.png"
                  alt="Upload Icon"
                  className="h-8 w-8 mb-3"
                />
                <span className="text-[#F4802C] text-[13px] font-Montserratmedium">
                  Upload new {activeMediaTab === "Video gallery" ? "video" : "photo"}
                </span>
                <input
                  id={`media-upload-${activeMediaTab}`}
                  type="file"
                  accept={activeMediaTab === "Video gallery" ? "video/*" : "image/*"}
                  multiple={activeMediaTab !== "Portfolio"}
                  className="hidden"
                  onChange={async (e) => {
                    const files = e.target.files ? Array.from(e.target.files) : [];
                    if (!files.length) return;

                    if (activeMediaTab === "Video gallery") {
                      const blobUrls = files.map((f) => URL.createObjectURL(f));
                      setVideoGallery((prev) => [...prev, ...blobUrls]);
                      const urls = await uploadMultipleFiles(files);
                      if (urls.length) setVideoGalleryForSubmit((prev) => [...prev, ...urls]);
                    } else if (activeMediaTab === "Photo gallery") {
                      const blobUrls = files.map((f) => URL.createObjectURL(f));
                      setPhotoGallery((prev) => [...prev, ...blobUrls]);
                      const urls = await uploadMultipleFiles(files);
                      if (urls.length) setPhotoGalleryForSubmit((prev) => [...prev, ...urls]);
                    } else if (activeMediaTab === "Portfolio") {
                      setPortfolio((prev) => [...prev, URL.createObjectURL(files[0])]);
                      const url = await uploadSingleFile(files[0]);
                      if (url) setPortfolioForSubmit((prev) => [...prev, url]);
                    }
                    e.target.value = "";
                  }}
                />
              </label>
            </div>

            <div className="image-strip-scroll flex-1 min-w-0 flex items-start gap-4 overflow-x-auto overflow-y-hidden pb-2">
              {activeMediaTab === "Photo gallery" &&
                photoGallery.map((image, index) => (
                  <div key={index} className="relative flex-shrink-0 w-[280px]">
                    <img
                      src={(typeof image === "string" ? image : (image?.url || image?.path || image?.src)) || IMG_PH}
                      alt={`Photo ${index + 1}`}
                      className="w-full h-28 md:h-32 object-cover rounded bg-gray-100"
                      onError={(e) => { e.target.src = IMG_PH; }}
                    />
                    <button
                      type="button"
                        onClick={() => {
                          setPhotoGallery((prev) => prev.filter((_, i) => i !== index));
                          setPhotoGalleryForSubmit((prev) => prev.filter((_, i) => i !== index));
                        }}
                      className="absolute bottom-2 left-1/2 -translate-x-1/2 flex h-8 w-8 items-center justify-center rounded-full bg-white border border-[#F3D5BF] shadow-sm hover:bg-[#FFF7F1] transition z-10"
                      aria-label="Remove image"
                    >
                      <img
                        src={DeleteIcon}
                        alt="Delete"
                        className="h-3.5 w-3.5 delete-icon-tint"
                      />
                    </button>
                  </div>
                ))}

              {activeMediaTab === "Video gallery" &&
                videoGallery.map((video, index) => (
                  <div key={index} className="relative flex-shrink-0 w-[280px] h-28 md:h-32 rounded overflow-hidden bg-gray-200">
                    <video
                      src={typeof video === "string" ? video : (video?.url || video?.path || video?.src) || ""}
                      className="w-full h-full object-cover"
                      controls
                      playsInline
                      onError={(e) => {
                        e.target.style.display = "none";
                        const parent = e.target.parentElement;
                        if (parent && !parent.querySelector(".video-fallback"))
                          parent.insertAdjacentHTML("beforeend", '<div class="video-fallback absolute inset-0 flex items-center justify-center text-gray-500 text-sm">Video</div>');
                      }}
                    />
                    <button
                      type="button"
                        onClick={() => {
                          setVideoGallery((prev) => prev.filter((_, i) => i !== index));
                          setVideoGalleryForSubmit((prev) => prev.filter((_, i) => i !== index));
                        }}
                      className="absolute bottom-2 left-1/2 -translate-x-1/2 flex h-8 w-8 items-center justify-center rounded-full bg-white border border-[#F3D5BF] shadow-sm hover:bg-[#FFF7F1] transition z-10"
                      aria-label="Remove video"
                    >
                      <img
                        src={DeleteIcon}
                        alt="Delete"
                        className="h-3.5 w-3.5 delete-icon-tint"
                      />
                    </button>
                  </div>
                ))}

              {activeMediaTab === "Portfolio" &&
                portfolio.map((image, index) => (
                  <div key={index} className="relative flex-shrink-0 w-[280px]">
                    <img
                      src={(typeof image === "string" ? image : (image?.url || image?.path || image?.src)) || IMG_PH}
                      alt="Portfolio"
                      className="w-full h-28 md:h-32 object-cover rounded bg-gray-100"
                      onError={(e) => { e.target.src = IMG_PH; }}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setPortfolio((prev) => prev.filter((_, i) => i !== index));
                        setPortfolioForSubmit((prev) => prev.filter((_, i) => i !== index));
                      }}
                      className="absolute bottom-2 left-1/2 -translate-x-1/2 flex h-8 w-8 items-center justify-center rounded-full bg-white border border-[#F3D5BF] shadow-sm hover:bg-[#FFF7F1] transition z-10"
                      aria-label="Remove image"
                    >
                      <img
                        src={DeleteIcon}
                        alt="Delete"
                        className="h-3.5 w-3.5 delete-icon-tint"
                      />
                    </button>
                  </div>
                ))}
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddService;
